import React, { useState } from "react"

import "./NotificationModal.scss"
import Backdrop from "../Backdrop/Backdrop"

export default function NotificationModal({ cycle }) {
  const [permission, setPermission] = useState(window.Notification?.permission)

  if (permission !== "default" || process.env.RAILS_ENV === "test") return null

  const handleClick = () => {
    Notification.requestPermission().then(setPermission)
  }

  return (
    <Backdrop>
      <div className={`NotificationModal NotificationModal--${cycle}`}>
        <p className="NotificationModal__description">
          Would you like a <strong>system notification</strong> when your timer
          ends?
        </p>

        <button className="NotificationModal__button" onClick={handleClick}>
          Make my choice
        </button>

        <div className="NotificationModal__disclaimer">
          <p>We'll only bother you this once.</p>

          <p>
            Should you change your mind, you can always change the permissions
            for the site through your browser's settings.
          </p>
        </div>
      </div>
    </Backdrop>
  )
}
